module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "validate-content",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    staticClass: "heading"
  }, [(_vm.validationSuccess) ? _c('i', {
    staticClass: "fa fa-2x fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.error.show) ? _c('i', {
    staticClass: "fa fa-2x fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n                Account Validation\n            ")])])]), _vm._v(" "), (_vm.validationSuccess) ? _c('div', [_c('strong', [_vm._v("Thank You! Your Account has been validated")]), _vm._v(" "), (!_vm.user) ? _c('h3', {
    staticClass: "redirectMsg"
  }, [_vm._v("Log In to TONE Networks!")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.error.show) ? _c('div', [_c('strong', [_vm._v("Sorry! Your Account could not be validated")]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.error.message))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right ",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-chevron-right ",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-chevron-right ",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            Redirecting now\n            "), _c('i', {
    staticClass: "fa fa-chevron-right ",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-chevron-right ",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-chevron-right ",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d18a2b6", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d18a2b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Validate.vue